Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.CheckboxGroup = (function () {

  function CheckboxGroup() {

    Monet.UI.Fields.Base.apply(this, arguments);

    this.createBaseStructure();
    this.checkboxes = [];

    this.setId = function (id) {
      this.id = id;
    };

    this.getId = function () {
      return this.id;
    };

    this.clear = function () {
      this.checkboxes.forEach((checkbox) => {
        checkbox.clear();
      });
    };

    this.setFieldDomains = function (fieldDomains) {
      fieldDomains.forEach((fieldDomain) => {
        this.setCheckbox({
          type: 'CHECKBOX',
          name: 'CheckboxItem_' + this.id,
          value: fieldDomain.value,
          id: fieldDomain.id,
          label: fieldDomain.description
        });
      });
    };

    this.setCheckbox = function (checkbox) {
      const checkboxField = new Monet.UI.Fields.Render(checkbox, this.entity).render();
      checkboxField.setChecked(false);
      checkboxField.setInputName(checkbox.id);
      checkboxField.rootEl.className = "checkbox_group_item";
      this.checkboxes.push(checkboxField);
    };

    this.setSelected = function (selected) {
      this.checkboxes.forEach((checkbox) => {
        if (selected[checkbox.name]) {
          checkbox.setChecked(selected[checkbox.name]);
        }
      });
    };

    this.setValue = function (selected) {
      this.setSelected(selected);
    };

    this.setDefaultValue = function (selected) {
      this.setSelected(selected);
    };

    this.getValue = function () {
      return this.checkboxes.reduce((acc, checkbox) => ({ ...acc, [checkbox.name]: checkbox.getValue() }), {});
    };

    this.getCheckboxes = function () {
      return this.checkboxes;
    };

    this.getCheckboxesSelected = function () {
      return this.checkboxes.filter((checkbox) => checkbox.input.checked === true);
    };

    this.createOptionsGroup = function () {
      this.checkboxes.forEach((checkbox) => {
        this.rootEl.appendChild(checkbox.rootEl);
      });
    };

    this.render = function () {
      this.createOptionsGroup();
      this.label.className += 'optionGroup-label';
      this.rootEl.className = 'optionGroup';

      return this.rootEl;
    };

  }

  return CheckboxGroup;

}());